import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  NgZone,
  OnInit,
  Renderer2, ViewEncapsulation
} from '@angular/core';

import { McRAIVideo } from '../../models/video';
import { MediaComponent } from '../media/media.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'mcrai-media[type=video]',
  template: `<iframe class="mcrai-media__video" [src]="sanitazedSrc"></iframe>
`,
  styles: [`.mcrai-media--video{display:block}.mcrai-media__video{width:100%;height:100%;border:0}`],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  preserveWhitespaces: false,
  host: {
    '[class.mcrai-media]': 'true',
    '[class.mcrai-media--video]': 'true'
  }
})
export class VideoComponent extends MediaComponent implements OnInit {
  private _data: McRAIVideo;

  @Input() set data(value: McRAIVideo) {
    this._data = value;

    if (value) {
      this._src = this._buildSrc(value.id);
    }
  }

  get sanitazedSrc(): SafeResourceUrl {
    return this._sanitizer.bypassSecurityTrustResourceUrl(this._src);
  }

  constructor(
    protected _elRef: ElementRef,
    protected _changeDetectorRef: ChangeDetectorRef,
    protected _renderer: Renderer2,
    protected _ngZone: NgZone,
    private _sanitizer: DomSanitizer
  ) {
    super(_elRef, _changeDetectorRef, _renderer, _ngZone);
  }

  ngOnInit() { }

  ngAfterViewInit() {
    const width  = this.toString(this._width);
    const height = this.toString(this._height);

    this._renderer.setStyle(this._elRef.nativeElement, 'width', width);
    this._renderer.setStyle(this._elRef.nativeElement, 'height', height);
  }

  private _buildSrc(id: string): string {
    return `https://www.youtube.com/embed/${id}`;
  }

}
